import { render, staticRenderFns } from "./CadastreDetailsModal.vue?vue&type=template&id=55f56144&scoped=true&"
import script from "./CadastreDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CadastreDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f56144",
  null
  
)

export default component.exports